export default {
  components() {
    return [
      {
        'component': 'search-start-end',
        label: '작성일',
        value: 'date',
        query: {'ss': 'startDate', 'ee': 'endDate'},
        options: {
          default: {sd: '', ed: ''},
        }
      },
      {
        'component': 'search-check-group', label: '', value: 'type', query: {'ck_l': 'checkList'},
        options: {
          list: [{text: '정기조사', value: '정기조사'}, {text: '수시조사', value: '수시조사'}],
          selectMaxCount: 1,
          default: [],

        }
      },
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['구분', '작성일']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 정기조사 / 수시조사
    if (search.type && search.type.length > 0) {
      conditions.push({key: 'body.regularly', operator: 'LIKE', value: search.type[0]})
    }

    //  검색일
    if (search.date) {
      conditions.push({key: 'created_at', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'created_at', operator: '<=', value: search.date.endDate})
    }

    //  검색조건
    const types = {
      '사업장명': 'body.stdInfo.field_name',
      '대상자 성명': 'body.targetInfo.name',
      '소속명': 'body.stdInfo.department',
      '부서명': 'body.stdInfo.section',
      '작성자': 'body.stdInfo.writer_name',
    }

    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },

  getHead: () => {
    return [{ name: '사업장명' }, { name: '구분' }, { name: '대상자 성명' }, { name: '소속명' }, { name: '부서명' }, { name: '작성자' }, { name: '작성일' }]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 사업장명
      case 1: return func.getContent(value).regularly // 구분
      case 2: return func.getContent(value).targetInfo.name // 대상자 성명
      case 3: return func.getContent(value).stdInfo.department // 소속명
      case 4: return func.getContent(value).stdInfo.section ? func.getContent(value).stdInfo.section : func.getContent(value).stdInfo.com_name // 부서명
      case 5: return func.getContent(value).stdInfo.writer_name // 작성자
      case 6: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  // getSearchKeyValue: (nav) =>  {
  //   if (nav.value.created_at) {
  //     nav.dateTarget = 'created_at'
  //     nav.dateBegin = 'nav.value.created_at.sDate'
  //     nav.dateEnd = 'nav.value.created_at.eDate'
  //   }
  //   return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  // },
  getSearchKeyword: (nav) => {},
  getSearchKeyValue: (nav) => {},

}
